import React, { useEffect, useState } from 'react'
import { getCourses } from '../../../firebase/utils';
import { Card, Container } from 'reactstrap'
import { Table } from 'antd'
import CalenderModal from './CalenderModal';
import { Btn } from '../../../AbstractElements';

const CoursesTab = ({ data }) => {
  const [courses, setCourses] = useState([])
  const [coursesData, setcoursesData] = useState([])
  const [loading, setLoading] = useState(false)
  const [calendarModel, setCalendarModel] = useState({
    show: false,
    details: null
  })
  const getCourse = async () => {
    try {
      setLoading(true);
      const res = await getCourses()
      setCourses(res);
      setLoading(false)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getCourse()
  }, [])

  useEffect(() => {
    if (data && data.courses) {
      const allCurses = data.courses.map((course) => {
        const cor = courses.find((v) => v.id === course.courseId);
        return { ...cor };
      });
      setcoursesData(allCurses);

    } else {
      setcoursesData([]);
    }
  }, [data, courses]);

  const coursesTableColumn = [
    {
      title: "COURSE NAME",
      dataIndex: "name",
    },
    {
      title: "START DATE",
      dataIndex: "startDate",
      render: (startDate) => {
        const formattedDate = new Date(startDate).toLocaleDateString("en-US");
        return formattedDate;
      },
    },
    {
      title: "END DATE",
      dataIndex: "endDate",
      render: (endDate) => {
        const formattedDate = new Date(endDate).toLocaleDateString("en-US");
        return formattedDate;
      },
    },
    {
      title: "STATUS",
      dataIndex: "isCurrent",
      render: (isCurrent) => (isCurrent ? "Yes" : "No"),
    },
    {
      title: 'ATTENDANCE',
      render: (e) => <Btn attrBtn={{
        color: "primary", onClick: () => setCalendarModel({ show: true, details: e })
      }}>View</Btn>
    },
  ]

  return (
    <>
      <div>
        {coursesData.length ?
          <Container fluid={true} className="dashboard-default user-details-modals">
            <Card className='p-3' style={{ display: 'flex', justifyContent: 'start'}}>
              <div style={{ marginBottom: '100px' }} className='ant-design-table not-margin'>
                <Table
                  loading={loading}
                  rowClassName={(record) => record ? 'table-row-text' : ''}
                  columns={coursesTableColumn}
                  dataSource={coursesData}
                  bordered={true}
                  pagination={false}
                />
              </div>
            </Card>
          </Container> :
          <h1 className="text-white text-xl text-center"> No Data Found </h1>}
      </div>
      {calendarModel.show && (
        <CalenderModal
          data={data}
          setCalendarModel={setCalendarModel}
          calendarModel={calendarModel}
        />
      )}
    </>
  )
}

export default CoursesTab